<script setup lang="ts">
const {
  t,
} = useI18n()
</script>

<template>
  <div class="mt2 flex items-start items-center px-4 py2 space-x-4 lg:px-8">
    <div class="flex-shrink-0">
      <div class="h-20 w-20 flex items-center justify-center">
        <NuxtImg src="/icons/insurance.svg" />
      </div>
    </div>
    <div>
      <h2 class="md:text-md text-sm">
        {{ t('trustable.productpage.customer_protection.label') }}
      </h2>
      <ul class="mt-2 space-y-2">
        <li class="flex items-start">
          <Icon name="i-mingcute:checkbox-fill" />
          <span class="ml-2 text-xs md:text-sm">
            {{ t('trustable.productpage.customer_protection.return_money_no_delivery') }}
          </span>
        </li>
        <li class="flex items-start">
          <Icon name="i-mingcute:checkbox-fill" />
          <span class="ml-2 text-xs md:text-sm">
            {{ t('trustable.productpage.customer_protection.return_money_not_as_described') }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
